import { useAuthUser } from "@/features/auth/AuthContext";
import { Routes } from "./routes";

const App = () => {
  const { isLoading } = useAuthUser();

  if (isLoading) {
    return <div>Loading...</div>;
  }

  return <Routes />;
};

export default App;
